import { DropdownOptionProps } from 'src/components/CookbookSelectWrapper/CookbookSelectWrapper';

export const filterOptions = (
  options: DropdownOptionProps[],
  searchValue: string
): DropdownOptionProps[] => {
  const trimmedSearchValue = searchValue.trim().toLowerCase();

  return options.filter((option) =>
    option.text.toLowerCase().includes(trimmedSearchValue)
  );
};
